import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedRow: null,
  formData: {
    group_id: '',
    group_name: '',
    group_descr: '',
    group_isdisabled: 0,
    detail_program: [],
    detail_user: [],
    detail_log: [],
    group_createdby: '',
    group_createddate: '',
    group_modifyby: '',
    group_modifydate: '',
    rowid: '',
  },
  dataList: [],
  totalData: 0,
  loading: false,
  error: null,
  loadingMessage: '',
  activeTab: 0,
};

const adm07groupSlice = createSlice({
  name: 'adm07group',
  initialState,
  reducers: {
    setSelectedRow: (state, action) => { state.selectedRow = action.payload; },
    setFormData: (state, action) => { state.formData = action.payload; },
    clearFormData: (state) => { state.formData = initialState.formData; },
    setLoading: (state, action) => { state.loading = action.payload; },
    setErrorMsg: (state, action) => { state.error = action.payload; },
    setLoadingMessage: (state, action) => { state.loadingMessage = action.payload; },
    setDataList: (state, action) => { state.dataList = action.payload; },
    setTotalData: (state, action) => { state.totalData = action.payload; },
    fetchDetailSuccess: (state, action) => {
      state.formData = { ...initialState.formData, ...action.payload };
      state.loading = false;
      state.error = null;
    },
    fetchDetailFailure: (state, action) => { state.loading = false; state.error = action.payload; },
    fetchDetailError: (state, action) => { state.loading = false; state.error = action.payload; },
    updateFormData: (state, action) => {
      state.loading = false;
      state.formData = { ...state.formData, ...action.payload };
    },
    resetState: () => initialState,
    setActiveTab: (state, action) => { state.activeTab = action.payload; },
    clearModuleState: (state) => {
      state.activeTab = 0;
      state.dataList = [];
      state.totalData = 0;
      state.loading = false;
      state.loadingMessage = '';
      state.error = null;
      state.selectedRow = null;
      state.formData = initialState.formData;
    },
  },
});

export const {
  setSelectedRow,
  setFormData,
  clearFormData,
  setLoading,
  setErrorMsg,
  setLoadingMessage,
  setDataList,
  setTotalData,
  fetchDetailSuccess,
  fetchDetailFailure,
  fetchDetailError,
  updateFormData,
  resetState,
  setActiveTab,
  clearModuleState,
} = adm07groupSlice.actions;

export default adm07groupSlice.reducer;
